// extracted by mini-css-extract-plugin
export default {"customModalContainer":"Modal_customModalContainer__J1pZW","modalTitle":"Modal_modalTitle__1JYd+","modalText":"Modal_modalText__SBEaI"};